import { render, staticRenderFns } from "./CarpoolRemovePaxs.vue?vue&type=template&id=2214b8d0&"
import script from "./CarpoolRemovePaxs.vue?vue&type=script&lang=ts&"
export * from "./CarpoolRemovePaxs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports